/* ═══════════════════════════════════════════════════════════
   NÖUT · Additions JS · v4
   Delegated events sobre .nout-swatch y [data-nout-add]
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.nout-swatch:not(.nout-swatch--label)');
    if (swatch) {
      handleSwatchClick(swatch);
      return;
    }

    var qtyBox = event.target.closest('.nout-qty, .nout-qty-box');
    if (qtyBox) {
      event.preventDefault();
      handleQtyBoxClick(qtyBox);
      return;
    }

    var scrollLink = event.target.closest('[data-nout-scroll]');
    if (scrollLink) {
      var href = scrollLink.getAttribute('href') || '';
      var hashIdx = href.indexOf('#');
      if (hashIdx !== -1) {
        var id = href.substring(hashIdx + 1);
        var target = document.getElementById(id) ||
                     document.querySelector('main product-grid, main #product-grid, main #products, main .collection');
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    // Individual card: scroll a la grid de variantes de color (.nout-vgrid)
    var individualCard = event.target.closest('.nout-card--individual');
    if (individualCard) {
      event.preventDefault();
      // 1) buscar la variante grid, es donde estan los colores
      var target = document.querySelector('.nout-vgrid');
      // 2) fallback: siguiente section no vacia
      if (!target) {
        var chooserSection = individualCard.closest('.nout-chooser') || individualCard.closest('section');
        var next = chooserSection ? chooserSection.nextElementSibling : null;
        while (next && (next.offsetHeight === 0 || next.hidden)) {
          next = next.nextElementSibling;
        }
        target = next;
      }
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      }
      return;
    }

    var addBtn = event.target.closest('[data-nout-add]');
    if (addBtn) {
      event.preventDefault();
      handleAddClick(addBtn);
    }
  });

  function handleQtyBoxClick(box) {
    var group = box.closest('.nout-qty-grid, .nout-qty-boxes');
    if (!group) return;
    var groupId = group.getAttribute('data-nout-qty-group');
    var priceFooter = document.querySelector('[data-nout-price-target="' + groupId + '"]');
    if (!priceFooter) return;

    // Si el click viene desde el input, no hagas nada — el input maneja su blur
    if (box.querySelector('.nout-qty__input')) return;

    var qty = box.getAttribute('data-qty') || '';
    var rawPrice = box.getAttribute('data-price') || '';
    var cleanPrice = String(rawPrice).replace(/[^0-9.]/g, '');
    var isQuoteTier = !cleanPrice || parseFloat(cleanPrice) === 0;

    // Si es tier de cotizacion — transformar en input inline
    if (isQuoteTier) {
      var qtyDefault = qty.replace(/\D/g, '') || '96';
      var current = box.getAttribute('data-custom-qty') || qtyDefault;
      var originalHTML = box.getAttribute('data-original-html') || box.innerHTML;
      box.setAttribute('data-original-html', originalHTML);

      // marca activo primero
      var siblings = group.querySelectorAll('.nout-qty, .nout-qty-box');
      for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-active');
      box.classList.add('is-active');

      // reemplazar contenido por input
      box.innerHTML = '';
      var input = document.createElement('input');
      input.type = 'number';
      input.inputMode = 'numeric';
      input.pattern = '[0-9]*';
      input.min = qtyDefault;
      input.value = current;
      input.className = 'nout-qty__input';
      input.placeholder = qtyDefault + '+';
      box.appendChild(input);
      // focus con delay para que el layout se estabilice
      setTimeout(function () { input.focus(); input.select(); }, 30);

      var commit = function () {
        var val = String(input.value).replace(/\D/g, '');
        if (!val || parseInt(val, 10) < 1) val = qtyDefault;
        box.setAttribute('data-custom-qty', val);
        // restaurar contenido visual del box con el nuevo numero
        box.innerHTML = val + '+';
        updateQuoteTierDisplay(box, priceFooter, val);
      };
      input.addEventListener('blur', commit);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      });
      // trigger initial display update with current value
      updateQuoteTierDisplay(box, priceFooter, current);
      return;
    }

    // Tier normal con precio numerico
    box.removeAttribute('data-custom-qty');
    var siblings2 = group.querySelectorAll('.nout-qty, .nout-qty-box');
    for (var j = 0; j < siblings2.length; j++) siblings2[j].classList.remove('is-active');
    box.classList.add('is-active');
    // restaurar cualquier tier previo que este en modo input
    group.querySelectorAll('[data-original-html]').forEach(function (b) {
      if (b !== box) {
        var oh = b.getAttribute('data-original-html');
        if (b.querySelector('.nout-qty__input')) b.innerHTML = oh;
      }
    });

    var save = box.getAttribute('data-save') || '';
    var amountEl = priceFooter.querySelector('.amount');
    var badgeEl = priceFooter.querySelector('.nout-price-badge');
    var priceNum = parseFloat(cleanPrice);

    var formatted = '$' + priceNum.toLocaleString('es-MX');
    if (amountEl) {
      amountEl.innerHTML = '<span class="nout-price-value">' + formatted + '</span><span class="unit">MXN c/u</span>';
    }
    if (badgeEl) badgeEl.textContent = save ? '−' + save + '%' : '';
  }

  function updateQuoteTierDisplay(box, priceFooter, customQty) {
    var amountEl = priceFooter.querySelector('.amount');
    var badgeEl = priceFooter.querySelector('.nout-price-badge');
    if (amountEl) amountEl.innerHTML = '<span class="nout-price-value">A medida · ' + customQty + ' pzas</span>';
    if (badgeEl) badgeEl.textContent = 'cotización';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var groups = document.querySelectorAll('.nout-qty-grid, .nout-qty-boxes');
    for (var i = 0; i < groups.length; i++) {
      var active = groups[i].querySelector('.nout-qty.is-active, .nout-qty-box.is-active');
      if (active) handleQtyBoxClick(active);
    }
  });

  function handleSwatchClick(swatch) {
    var swatchesContainer = swatch.closest('.nout-swatches');
    if (!swatchesContainer) return;

    var siblings = swatchesContainer.querySelectorAll('.nout-swatch');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('is-active');
    }
    swatch.classList.add('is-active');

    var combo = swatch.closest('.nout-combo');
    if (!combo) return;

    // Swap thumbnail image to the selected variant's image
    var variantImage = swatch.getAttribute('data-variant-image');
    if (variantImage) {
      var thumbImg = combo.querySelector('.nout-combo__img');
      if (thumbImg) {
        thumbImg.setAttribute('src', variantImage);
        thumbImg.removeAttribute('srcset');
        thumbImg.removeAttribute('sizes');
      }
    }

    var addBtn = combo.querySelector('[data-nout-add]');
    if (!addBtn) return;

    var variantId = swatch.getAttribute('data-variant-id');
    var colorName = swatch.getAttribute('data-color-name');

    if (variantId) {
      addBtn.setAttribute('data-selected-variant', variantId);
    }
    if (colorName) {
      var baseLabel = addBtn.getAttribute('data-base-label') || 'Agregar';
      addBtn.textContent = '+ ' + baseLabel + ' ' + colorName;
    }
  }

  function handleAddClick(btn) {
    var variantId = btn.getAttribute('data-selected-variant') ||
                    btn.getAttribute('data-default-variant');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw new Error(err.description || 'cart-add-failed');
        });
      }
      return response.json();
    })
    .then(function () {
      btn.classList.add('is-success');
      btn.textContent = '✓ Agregado';
      openCartDrawer();
      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('is-success');
        btn.disabled = false;
      }, 1800);
    })
    .catch(function (err) {
      console.error('[nout] add-to-cart failed:', err);
      btn.textContent = 'Error, reintentar';
      btn.disabled = false;
      setTimeout(function () {
        btn.textContent = originalText;
      }, 2500);
    });
  }

  function openCartDrawer() {
    // Dawn ≥ 2.0 usa <cart-drawer> como custom element
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    // Fallback: cart-notification (temas con notification en vez de drawer)
    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.open === 'function') {
      notif.open();
      return;
    }

    // Último recurso: refresh de secciones del carrito vía section rendering
    var url = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    fetch(url + '?section_id=cart-drawer', {
      headers: { 'Accept': 'text/html' }
    })
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) {
        var currentDrawer = document.querySelector('cart-drawer');
        if (currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          if (typeof currentDrawer.open === 'function') currentDrawer.open();
        }
      }
    });
  }
})();

/* ═══════════════════════════════════════════════════════════
   NÖUT · Modals + Ö3 wizard + Mayoreo personalization + Quote form
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Modal open/close ─────────────────────────────── */
  function openModal(id) {
    var modal = document.getElementById('nout-modal-' + id);
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-nout-open-modal]');
    if (trigger) {
      event.preventDefault();
      var id = trigger.getAttribute('data-nout-open-modal');
      if (id === 'o3') openO3Wizard();
      else if (id === 'quote') openQuoteModal(trigger);
      return;
    }
    var closer = event.target.closest('[data-nout-close-modal]');
    if (closer) {
      var modal = closer.closest('.nout-modal');
      closeModal(modal);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nout-modal:not([hidden])').forEach(closeModal);
    }
  });

  /* ── Personalization row (Mayoreo) ────────────────── */
  document.addEventListener('click', function (event) {
    var perso = event.target.closest('.nout-perso');
    if (!perso || perso.classList.contains('is-locked')) return;
    event.preventDefault();
    var row = perso.closest('.nout-perso-row');
    if (!row) return;
    row.querySelectorAll('.nout-perso').forEach(function (b) { b.classList.remove('is-active'); });
    perso.classList.add('is-active');
    updateWholesalePrice(row);
  });

  function updateWholesalePrice(persoRow) {
    var groupId = persoRow.getAttribute('data-nout-perso-group');
    var qtyGrid = document.querySelector('.nout-qty-grid[data-nout-qty-group="' + groupId + '"]');
    var priceFooter = document.querySelector('[data-nout-price-target="' + groupId + '"]');
    if (!qtyGrid || !priceFooter) return;

    var activeQty = qtyGrid.querySelector('.nout-qty.is-active');
    if (!activeQty) return;

    var qty = activeQty.getAttribute('data-qty') || '';
    var rawPrice = activeQty.getAttribute('data-price') || '';
    var save = activeQty.getAttribute('data-save') || '';
    var qtyNum = parseInt(qty.replace(/\D/g, ''), 10) || 0;
    var basePrice = parseFloat(String(rawPrice).replace(/[^0-9.]/g, ''));

    var perso = persoRow.querySelector('.nout-perso.is-active');
    var persoType = perso ? perso.getAttribute('data-perso') : 'none';
    var dtfExtra = parseFloat(persoRow.getAttribute('data-perso-dtf')) || 0;
    var seriExtra = parseFloat(persoRow.getAttribute('data-perso-serigrafia')) || 0;
    var extra = persoType === 'dtf' ? dtfExtra : persoType === 'serigrafia' ? seriExtra : 0;

    var valueEl = priceFooter.querySelector('.nout-price-value');
    var amountEl = priceFooter.querySelector('.amount');
    var badgeEl = priceFooter.querySelector('.nout-price-badge');

    if (!rawPrice || isNaN(basePrice) || basePrice === 0) {
      if (amountEl) amountEl.innerHTML = '<span class="nout-price-value">A medida</span>';
      if (badgeEl) badgeEl.textContent = '';
      updatePersoLockState(persoRow, qtyNum);
      return;
    }

    var unitTotal = basePrice + extra;
    var formatted = '$' + unitTotal.toLocaleString('es-MX');
    if (amountEl) {
      var suffix = persoType !== 'none' ? ' <small style="font-family:var(--nout-font-body);font-size:13px;color:var(--nout-fg-2);font-weight:500">c/u</small>' : ' <span class="unit">MXN</span>';
      amountEl.innerHTML = '<span class="nout-price-value">' + formatted + '</span>' + suffix;
    }
    if (badgeEl) {
      var totalOrder = unitTotal * qtyNum;
      badgeEl.textContent = 'total $' + totalOrder.toLocaleString('es-MX');
    }
    updatePersoLockState(persoRow, qtyNum);
  }

  function updatePersoLockState(persoRow, qtyNum) {
    var seriBtn = persoRow.querySelector('.nout-perso[data-perso="serigrafia"]');
    if (!seriBtn) return;
    var min = parseInt(seriBtn.getAttribute('data-min'), 10) || 48;
    if (qtyNum < min) {
      seriBtn.classList.add('is-locked');
      if (seriBtn.classList.contains('is-active')) {
        seriBtn.classList.remove('is-active');
        var noneBtn = persoRow.querySelector('.nout-perso[data-perso="none"]');
        if (noneBtn) noneBtn.classList.add('is-active');
      }
    } else {
      seriBtn.classList.remove('is-locked');
    }
  }

  // Hook qty click to also refresh perso row
  document.addEventListener('click', function (event) {
    var qtyBox = event.target.closest('.nout-qty');
    if (!qtyBox) return;
    setTimeout(function () {
      var group = qtyBox.closest('.nout-qty-grid');
      if (!group) return;
      var groupId = group.getAttribute('data-nout-qty-group');
      var persoRow = document.querySelector('.nout-perso-row[data-nout-perso-group="' + groupId + '"]');
      if (persoRow) updateWholesalePrice(persoRow);
    }, 0);
  });

  // Init on load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.nout-perso-row').forEach(function (row) {
      updateWholesalePrice(row);
    });
  });

  /* ── Quote modal ───────────────────────────────────── */
  function openQuoteModal(trigger) {
    var card = trigger.closest('.nout-card--wholesale');
    if (!card) return;
    var qtyGrid = card.querySelector('.nout-qty-grid');
    var persoRow = card.querySelector('.nout-perso-row');
    var priceFooter = card.querySelector('[data-nout-price-target]');
    if (!qtyGrid || !priceFooter) return;

    var activeQty = qtyGrid.querySelector('.nout-qty.is-active');
    var activePerso = persoRow && persoRow.querySelector('.nout-perso.is-active');
    var priceAmount = priceFooter.querySelector('.amount');

    // Si el tier tiene custom-qty (96+ con input), usar esa
    var qtyText;
    if (activeQty) {
      var customQty = activeQty.getAttribute('data-custom-qty');
      qtyText = (customQty ? customQty : activeQty.getAttribute('data-qty')) + ' pzas';
    } else {
      qtyText = '—';
    }
    var persoText = activePerso ? activePerso.getAttribute('data-perso') : 'none';
    var persoLabel = { 'none': 'Sin Diseño', 'dtf': 'DTF (+$15)', 'serigrafia': 'Serigrafía (+$25)' }[persoText] || persoText;
    var priceText = priceAmount ? priceAmount.textContent.trim() : '—';

    var modal = document.getElementById('nout-modal-quote');
    if (!modal) return;
    modal.querySelector('[data-sum-qty]').textContent = qtyText;
    modal.querySelector('[data-sum-perso]').textContent = persoLabel;
    modal.querySelector('[data-sum-total]').textContent = priceText;

    // stash for submit
    modal.__nout_quote_data = { qty: qtyText, perso: persoLabel, total: priceText };
    openModal('quote');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quote-form]');
    if (!form) return;
    e.preventDefault();
    var modal = form.closest('.nout-modal');
    var status = form.querySelector('[data-quote-status]');
    var fd = new FormData(form);
    var payload = {
      source: 'nout-mayoreo',
      name: (fd.get('name') || '').trim(),
      phone: (fd.get('phone') || '').trim(),
      email: (fd.get('email') || '').trim(),
      note: (fd.get('note') || '').trim(),
      qty: modal.__nout_quote_data ? modal.__nout_quote_data.qty : '',
      perso: modal.__nout_quote_data ? modal.__nout_quote_data.perso : '',
      total: modal.__nout_quote_data ? modal.__nout_quote_data.total : ''
    };

    // Validate: name + phone (email removed per spec)
    if (!payload.name) {
      status.textContent = 'Escribe tu nombre.';
      status.className = 'nout-quote__note is-error';
      return;
    }
    if (!payload.phone) {
      status.textContent = 'Escribe tu teléfono (WhatsApp).';
      status.className = 'nout-quote__note is-error';
      return;
    }

    var webhook = modal.getAttribute('data-webhook');
    var email = modal.getAttribute('data-email');
    var honeypot = form.querySelector('input[name="website"]');
    var honeypotValue = honeypot ? honeypot.value : '';

    status.textContent = 'Enviando…';
    status.className = 'nout-quote__note';

    // Extract qty number and price from summary strings
    var qtyNum = parseInt(String(payload.qty).replace(/\D/g, ''), 10) || 0;
    var priceMatch = String(payload.total).match(/[\d,]+/);
    var unitPrice = priceMatch ? parseFloat(priceMatch[0].replace(/,/g, '')) : 0;

    // Detect personalization method + cost
    var persoMethod = '';
    var persoCost = 0;
    var persoNote = '';
    var persoStr = String(payload.perso || '').toLowerCase();
    if (persoStr.indexOf('serigraf') !== -1) { persoMethod = 'Serigrafia'; persoCost = 25; }
    else if (persoStr.indexOf('dtf') !== -1) { persoMethod = 'DTF'; persoCost = 15; }
    else if (persoStr.indexOf('laser') !== -1) { persoMethod = 'Laser'; persoCost = 10; }

    // Payload que espera el ERP inbox-landing.php
    var erpPayload = {
      nombre: payload.name,
      email: payload.email || '',
      telefono: payload.phone || '',
      whatsapp: payload.phone || '',
      notas: 'Cotizacion mayoreo desde landing NOUT' + (payload.note ? ' · ' + payload.note : ''),
      tipo_entrega: 'Nacional',
      costo_envio: 0,
      external_ref: 'nout-mayoreo-' + Date.now(),
      items: [{
        descripcion: 'Pasta Suave x' + qtyNum + (persoMethod ? ' · ' + persoMethod : ''),
        cantidad: qtyNum,
        precio_unitario: unitPrice - persoCost,
        personalizacion_metodo: persoMethod,
        personalizacion_costo: persoCost,
        personalizacion_nota: payload.note || ''
      }]
    };

    // Include honeypot if filled (middleware ignores it silently)
    if (honeypotValue) erpPayload.website = honeypotValue;

    var submitPromise;
    if (webhook) {
      submitPromise = fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(erpPayload)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.error || 'server-error'); });
        return r.json();
      });
    } else {
      var body = 'Cotización mayoreo NÖUT\n' +
        '\nNombre: ' + payload.name +
        '\nTeléfono: ' + payload.phone +
        '\nEmail: ' + payload.email +
        '\nCantidad: ' + payload.qty +
        '\nPersonalización: ' + payload.perso +
        '\nPrecio estimado: ' + payload.total +
        '\nNota: ' + payload.note;
      window.location.href = 'mailto:' + email + '?subject=' + encodeURIComponent('Cotización mayoreo NÖUT') + '&body=' + encodeURIComponent(body);
      submitPromise = Promise.resolve();
    }

    submitPromise.then(function () {
      status.textContent = '✓ Cotización enviada. Te contactamos pronto.';
      status.className = 'nout-quote__note is-ok';
      setTimeout(function () { closeModal(modal); form.reset(); status.textContent = ''; }, 2500);
    }).catch(function () {
      status.textContent = 'Error, intenta de nuevo.';
      status.className = 'nout-quote__note is-error';
    });
  });


  /* ═══════════════════════════════════════════════════════
     Ö3 Wizard · Opción B (3 slots visibles, tap para editar)
     Real inventory sync via /products/{handle}.js
     ═══════════════════════════════════════════════════════ */
  var COLOR_MAP = {
    'negro': '#1a1a1a', 'negro grafito': '#1a1a1a', 'black': '#1a1a1a',
    'blanco': '#f6f6f2', 'white': '#f6f6f2',
    'eco': '#a48a6b', 'kraft': '#a48a6b', 'natural': '#a48a6b',
    'rojo vino': '#5c1a1e', 'vino': '#5c1a1e', 'bordeaux': '#5c1a1e',
    'rojo carmesi': '#a11d2b', 'rojo carmesí': '#a11d2b', 'rojo': '#a11d2b',
    'azul ultramar': '#1f3a6b', 'ultramar': '#1f3a6b', 'azul marino': '#1f3a6b',
    'azul electrico': '#2b6cb0', 'azul eléctrico': '#2b6cb0',
    'gris agata': '#7a7570', 'gris ágata': '#7a7570', 'gris': '#7a7570',
    'amarillo': '#f2c94c',
    'naranja': '#eb6b3a',
    'rosa': '#e88bb7', 'rosada': '#e88bb7',
    'verde limon': '#7fbf3f', 'verde limón': '#7fbf3f', 'verde': '#7fbf3f'
  };
  function hexFor(name) {
    return COLOR_MAP[String(name).toLowerCase()] || '#c0c0c0';
  }

  // Genera background-image SVG segun el interior (Rayas / Lisas / Puntos)
  // Retorna { pattern: 'url(...)' | 'none', kind: 'rayas' | 'puntos' | 'lisas' }
  function interiorPattern(name) {
    var n = String(name || '').toLowerCase();
    if (n.indexOf('raya') !== -1) {
      // 4 lineas horizontales edge-to-edge (x=0 a x=100)
      var svg = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' preserveAspectRatio=\'none\'>' +
        '<line x1=\'0\' y1=\'20\' x2=\'100\' y2=\'20\' stroke=\'%237a7570\' stroke-width=\'1.4\'/>' +
        '<line x1=\'0\' y1=\'40\' x2=\'100\' y2=\'40\' stroke=\'%237a7570\' stroke-width=\'1.4\'/>' +
        '<line x1=\'0\' y1=\'60\' x2=\'100\' y2=\'60\' stroke=\'%237a7570\' stroke-width=\'1.4\'/>' +
        '<line x1=\'0\' y1=\'80\' x2=\'100\' y2=\'80\' stroke=\'%237a7570\' stroke-width=\'1.4\'/>' +
        '</svg>';
      return { pattern: "url(\"data:image/svg+xml;utf8," + svg + "\")", kind: 'rayas' };
    }
    if (n.indexOf('punto') !== -1) {
      // Reticula 4x4 espaciado uniforme (12.5, 37.5, 62.5, 87.5)
      var dots = '';
      var pos = [12.5, 37.5, 62.5, 87.5];
      for (var i = 0; i < pos.length; i++) {
        for (var j = 0; j < pos.length; j++) {
          dots += '<circle cx=\'' + pos[j] + '\' cy=\'' + pos[i] + '\' r=\'3\' fill=\'%237a7570\'/>';
        }
      }
      var svg2 = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\'>' + dots + '</svg>';
      return { pattern: "url(\"data:image/svg+xml;utf8," + svg2 + "\")", kind: 'puntos' };
    }
    // Lisas: sin patron, solo fondo hueso
    return { pattern: 'none', kind: 'lisas' };
  }

  var o3State = null;

  function openO3Wizard() {
    var modal = document.getElementById('nout-modal-o3');
    if (!modal) return;
    if (!o3State) initO3State(modal);
    openModal('o3');
    if (!o3State.loaded) {
      loadO3Sources(modal);
    } else {
      renderO3();
    }
  }

  function initO3State(modal) {
    var sources;
    try { sources = JSON.parse(modal.getAttribute('data-sources') || '[]'); }
    catch (e) { sources = []; }
    o3State = {
      modal: modal,
      variantId: modal.getAttribute('data-o3-variant-id'),
      price: modal.getAttribute('data-o3-price'),
      sources: sources,
      colors: [],
      slots: [
        { color: null, interior: null, variantId: null },
        { color: null, interior: null, variantId: null },
        { color: null, interior: null, variantId: null }
      ],
      editingSlot: 0,
      loaded: false
    };
  }

  function loadO3Sources(modal) {
    var colorsEl = modal.querySelector('[data-colors]');
    if (!o3State.sources.length) {
      colorsEl.innerHTML = '<div class="nout-o3__loading">⚠️ Falta configurar los productos fuente en el editor del tema (Section → Ö3 Configurator).</div>';
      return;
    }
    colorsEl.innerHTML = '<div class="nout-o3__loading">Cargando colores…</div>';
    Promise.all(o3State.sources.map(function (s) {
      return fetch(s.url).then(function (r) { return r.json(); }).catch(function () { return null; });
    })).then(function (results) {
      var colorsByName = {};
      results.forEach(function (product) {
        if (!product || !product.variants) return;
        var colorOptIdx = -1;
        var interiorOptIdx = -1;
        // Shopify returns options as ARRAY OF OBJECTS {name, position, values}
        // OR sometimes as array of strings. Handle both.
        (product.options || []).forEach(function (opt, i) {
          var name = (typeof opt === 'string') ? opt : (opt && opt.name) || '';
          var ol = String(name).toLowerCase();
          if (ol.indexOf('color') !== -1) colorOptIdx = i;
          if (ol.indexOf('interior') !== -1) interiorOptIdx = i;
        });
        product.variants.forEach(function (v) {
          var color = colorOptIdx >= 0 ? v['option' + (colorOptIdx + 1)] : (v.option1 || '—');
          var interior = interiorOptIdx >= 0 ? v['option' + (interiorOptIdx + 1)] : 'default';
          if (!color) return;
          var interiorClean = String(interior).replace(/^Hojas\s+/i, '');
          var imgSrc = v.featured_image && v.featured_image.src ? v.featured_image.src : null;
          if (!colorsByName[color]) {
            colorsByName[color] = {
              name: color,
              hex: hexFor(color),
              image: imgSrc,   // primera imagen encontrada como default del color
              variants: []
            };
          } else if (!colorsByName[color].image && imgSrc) {
            colorsByName[color].image = imgSrc;
          }
          colorsByName[color].variants.push({
            id: v.id,
            interior: interiorClean,
            available: v.available,
            image: imgSrc
          });
        });
      });
      o3State.colors = Object.keys(colorsByName).map(function (k) { return colorsByName[k]; });
      if (o3State.colors.length === 0) {
        colorsEl.innerHTML = '<div class="nout-o3__loading">⚠️ No se encontraron colores. Verifica que los productos fuente tengan opción "Color" configurada.</div>';
      }
      o3State.loaded = true;
      renderO3();
    });
  }

  function renderO3() {
    var modal = o3State.modal;
    var slotIdx = o3State.editingSlot;
    var editingSlot = o3State.slots[slotIdx];

    // ── Render los 3 slots (mitad color arriba, mitad interior abajo) ──
    var slotEls = modal.querySelectorAll('.nout-o3__slot');
    for (var i = 0; i < slotEls.length; i++) {
      var s = slotEls[i];
      var st = o3State.slots[i];
      var isFilled = !!(st.color && st.interior);
      s.classList.toggle('is-editing', i === slotIdx);
      s.classList.toggle('is-filled', isFilled);
      s.classList.toggle('is-empty', !st.color);
      var book = s.querySelector('[data-book]');
      if (!book) {
        console.warn('[nout-o3] slot', i, 'no tiene [data-book], skip');
        continue;
      }

      // Garantizar que los children color+interior existan (defensivo · si el snippet
      // fue sobreescrito por un theme update, los recreamos)
      var colorEl = book.querySelector('[data-book-color]');
      var interiorEl = book.querySelector('[data-book-interior]');
      if (!colorEl) {
        colorEl = document.createElement('div');
        colorEl.className = 'nout-o3__book__color';
        colorEl.setAttribute('data-book-color', '');
        book.appendChild(colorEl);
      }
      if (!interiorEl) {
        interiorEl = document.createElement('div');
        interiorEl.className = 'nout-o3__book__interior';
        interiorEl.setAttribute('data-book-interior', '');
        book.appendChild(interiorEl);
      }

      // limpia clases de patron anteriores
      book.classList.remove('nout-o3__book--int-rayas', 'nout-o3__book--int-puntos', 'nout-o3__book--int-lisas');

      if (st.color) {
        book.classList.remove('nout-o3__book--empty');
        // Aplicamos inline directo al children ademas de la CSS var, defensivo contra overrides
        book.style.setProperty('--book-color', st.color.hex);
        colorEl.style.background = st.color.hex;

        if (st.interior) {
          var p = interiorPattern(st.interior);
          book.classList.add('nout-o3__book--int-' + p.kind);
          book.style.setProperty('--book-interior-bg', '#f4efe6');
          book.style.setProperty('--book-interior-pattern', p.pattern);
          interiorEl.style.backgroundColor = '#f4efe6';
          interiorEl.style.backgroundImage = p.pattern;
          interiorEl.style.backgroundRepeat = 'no-repeat';
          interiorEl.style.backgroundPosition = 'center';
          interiorEl.style.backgroundSize = (p.kind === 'puntos') ? 'contain' : '100% 100%';
        } else {
          book.style.setProperty('--book-interior-bg', '#f5f5f7');
          book.style.setProperty('--book-interior-pattern', 'none');
          interiorEl.style.backgroundColor = '#f5f5f7';
          interiorEl.style.backgroundImage = 'none';
        }
      } else {
        book.classList.add('nout-o3__book--empty');
        book.style.setProperty('--book-color', 'transparent');
        book.style.setProperty('--book-interior-bg', 'transparent');
        book.style.setProperty('--book-interior-pattern', 'none');
        colorEl.style.background = 'transparent';
        interiorEl.style.backgroundColor = 'transparent';
        interiorEl.style.backgroundImage = 'none';
      }
    }

    // ── Configurator header (solo Libreta X · sin status text) ──
    modal.querySelector('[data-cfg-slot]').textContent = 'Libreta 0' + (slotIdx + 1);

    // ── Colors ──────────────────
    var colorsEl = modal.querySelector('[data-colors]');
    colorsEl.innerHTML = o3State.colors.map(function (c, idx) {
      var anyAvail = c.variants.some(function (v) { return v.available; });
      var isSel = editingSlot.color && editingSlot.color.name === c.name;
      return '<button type="button" class="nout-o3__color' + (isSel ? ' is-selected' : '') + '" ' +
        'style="background:' + c.hex + '"' +
        (anyAvail ? '' : ' disabled') +
        ' data-color-idx="' + idx + '" title="' + c.name + (anyAvail ? '' : ' (agotado)') + '"></button>';
    }).join('');

    // ── Interiors (siempre 3 opciones fijas · locked hasta que se elija color) ──
    // Rayas, Lisas, Puntos siempre visibles. Se desbloquean solo las disponibles
    // para el color elegido. Si "Puntos" no existe en inventario, queda locked
    // permanentemente hasta que se agregue como variante en Shopify Admin.
    var FIXED_INTERIORS = ['Rayas', 'Lisas', 'Puntos'];
    var intPanel = modal.querySelector('[data-interiors]');
    var interiorsMap = {};
    if (editingSlot.color) {
      editingSlot.color.variants.forEach(function (v) {
        // match case-insensitive con el label fijo
        var match = FIXED_INTERIORS.find(function (label) {
          return String(v.interior).toLowerCase() === label.toLowerCase();
        });
        var key = match || v.interior;
        if (!interiorsMap[key]) interiorsMap[key] = { id: v.id, available: v.available };
        else if (v.available) interiorsMap[key].available = true;
      });
    }
    intPanel.innerHTML = FIXED_INTERIORS.map(function (label) {
      var opt = interiorsMap[label];
      var available = !!(opt && opt.available);
      var isSel = editingSlot.interior && String(editingSlot.interior).toLowerCase() === label.toLowerCase();
      var cls = 'nout-o3__interior' + (isSel ? ' is-selected' : '') + (available ? '' : ' is-locked');
      return '<button type="button" class="' + cls + '"' +
        (available ? '' : ' disabled') +
        ' data-interior="' + label + '"' +
        (opt ? ' data-variant-id="' + opt.id + '"' : '') +
        '>' + label + '</button>';
    }).join('');

    // ── Foot ──────────────────
    var filledCount = o3State.slots.filter(function (s) { return s.color && s.interior; }).length;
    modal.querySelector('[data-filled-count]').textContent = filledCount + ' de 3';
    var addBtn = modal.querySelector('[data-add-cart]');
    addBtn.disabled = filledCount < 3;
    if (filledCount === 3) {
      addBtn.textContent = 'Agregar al carrito';
    } else {
      var missing = 3 - filledCount;
      addBtn.textContent = missing === 3 ? 'Elige las 3' : 'Faltan ' + missing;
    }
  }

  document.addEventListener('click', function (event) {
    // click en un slot → cambiar editing
    var slot = event.target.closest('.nout-o3__slot');
    if (slot && o3State) {
      var idx = parseInt(slot.getAttribute('data-slot'), 10) - 1;
      if (idx >= 0 && idx <= 2 && idx !== o3State.editingSlot) {
        o3State.editingSlot = idx;
        renderO3();
      }
      return;
    }
    // click en color
    var colorBtn = event.target.closest('.nout-o3__color');
    if (colorBtn && !colorBtn.disabled && o3State) {
      var cidx = parseInt(colorBtn.getAttribute('data-color-idx'), 10);
      var color = o3State.colors[cidx];
      o3State.slots[o3State.editingSlot].color = color;
      // Reset interior si el nuevo color no tiene el interior actual disponible
      var currentInt = o3State.slots[o3State.editingSlot].interior;
      if (currentInt) {
        var matchingVar = color.variants.find(function (v) { return v.interior === currentInt && v.available; });
        if (matchingVar) {
          o3State.slots[o3State.editingSlot].variantId = matchingVar.id;
        } else {
          o3State.slots[o3State.editingSlot].interior = null;
          o3State.slots[o3State.editingSlot].variantId = null;
        }
      }
      renderO3();
      return;
    }
    // click en interior
    var intBtn = event.target.closest('.nout-o3__interior');
    if (intBtn && !intBtn.disabled && o3State) {
      o3State.slots[o3State.editingSlot].interior = intBtn.getAttribute('data-interior');
      o3State.slots[o3State.editingSlot].variantId = intBtn.getAttribute('data-variant-id');
      // Auto-advance al siguiente slot vacio (si hay)
      var allDone = o3State.slots.every(function (s) { return s.color && s.interior; });
      if (!allDone) {
        for (var j = 1; j <= 3; j++) {
          var nextIdx = (o3State.editingSlot + j) % 3;
          var ns = o3State.slots[nextIdx];
          if (!ns.color || !ns.interior) {
            o3State.editingSlot = nextIdx;
            break;
          }
        }
      }
      renderO3();
      return;
    }
    // add to cart
    var add = event.target.closest('[data-add-cart]');
    if (add && !add.disabled && o3State) {
      addO3ToCart(add);
      return;
    }
  });

  function addO3ToCart(btn) {
    // Nuevo modelo: agrega 3 variantes REALES al carrito (no un bundle virtual).
    // Shopify descuenta stock automatico. El descuento del bundle lo aplica
    // Shopify Admin > Discounts (Automatic Discount con condicion de cantidad).
    var allValid = o3State.slots.every(function (s) { return s.variantId; });
    if (!allValid) {
      alert('Faltan slots por elegir.');
      return;
    }
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Agregando…';

    // Un item por slot — cada uno con propiedades visibles para el cliente
    // y una property oculta _bundle_o3 que agrupa los 3 (util para el ERP).
    var items = o3State.slots.map(function (s, i) {
      return {
        id: parseInt(s.variantId, 10),
        quantity: 1,
        properties: {
          '_bundle_o3': 'Ö3-' + Date.now(), // agrupa los 3 con timestamp unico
          'Paquete': 'Ö3 Notes (' + (i + 1) + '/3)'
        }
      };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add-failed'); });
      return r.json();
    })
    .then(function () {
      btn.textContent = '✓ 3 libretas agregadas';
      setTimeout(function () {
        closeModal(o3State.modal);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        btn.textContent = originalText;
        btn.disabled = false;
        o3State.slots = [
          { color: null, interior: null, variantId: null },
          { color: null, interior: null, variantId: null },
          { color: null, interior: null, variantId: null }
        ];
        o3State.editingSlot = 0;
      }, 900);
    })
    .catch(function (err) {
      btn.textContent = 'Error, reintentar';
      btn.disabled = false;
      console.error('[nout-o3]', err);
      setTimeout(function () { btn.textContent = originalText; }, 2500);
    });
  }


})();

/* ═══════════════════════════════════════════════════════════
   Nout Variant Grid + Individual Modal
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var indState = null;

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.nout-vcard');
    if (card) {
      event.preventDefault();
      openIndividual(card);
      return;
    }
    var intBtn = event.target.closest('.nout-ind__interiors button');
    if (intBtn && !intBtn.disabled) {
      selectInterior(intBtn);
      return;
    }
    var minus = event.target.closest('[data-ind-qty-minus]');
    if (minus) { adjustQty(-1); return; }
    var plus = event.target.closest('[data-ind-qty-plus]');
    if (plus) { adjustQty(1); return; }
    var add = event.target.closest('[data-ind-add]');
    if (add && !add.disabled) {
      addIndividualToCart(add);
      return;
    }
  });

  function openIndividual(card) {
    var modal = document.getElementById('nout-modal-individual');
    if (!modal) return;

    var variants;
    try { variants = JSON.parse(card.getAttribute('data-variants') || '{}'); }
    catch (e) { variants = {}; }

    indState = {
      modal: modal,
      productTitle: card.getAttribute('data-product-title') || '',
      color: card.getAttribute('data-color') || '',
      price: card.getAttribute('data-price') || '',
      image: card.getAttribute('data-image') || '',
      variants: variants,
      selectedInterior: null,
      selectedVariantId: null
    };

    modal.querySelector('[data-ind-image]').src = indState.image;
    modal.querySelector('[data-ind-product]').textContent = indState.productTitle;
    modal.querySelector('[data-ind-color]').textContent = indState.color;
    modal.querySelector('[data-ind-price]').textContent = indState.price + ' · elige interior';
    modal.querySelector('[data-ind-qty-input]').value = 1;
    var statusEl = modal.querySelector('[data-ind-status]');
    if (statusEl) { statusEl.textContent = ''; statusEl.className = 'nout-ind__note'; }

    var intsEl = modal.querySelector('[data-ind-interiors]');
    var keys = Object.keys(variants);
    if (keys.length === 1 && keys[0] === 'default') {
      // Single-option product: no interior selector, just auto-select
      intsEl.innerHTML = '<span style="font-size:13px;color:var(--nout-fg-2)">Este producto no tiene interior.</span>';
      indState.selectedInterior = 'default';
      indState.selectedVariantId = variants['default'].id;
    } else {
      intsEl.innerHTML = keys.map(function (k) {
        var v = variants[k];
        var disabled = !v.available;
        return '<button type="button"' + (disabled ? ' disabled' : '') +
          ' data-int="' + escapeHtml(k) + '" data-vid="' + v.id + '">' + escapeHtml(k) + '</button>';
      }).join('');
    }

    var addBtn = modal.querySelector('[data-ind-add]');
    updateIndividualAddBtn(addBtn);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function selectInterior(btn) {
    var group = btn.parentElement;
    group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    indState.selectedInterior = btn.getAttribute('data-int');
    indState.selectedVariantId = btn.getAttribute('data-vid');
    var addBtn = indState.modal.querySelector('[data-ind-add]');
    updateIndividualAddBtn(addBtn);
  }

  function updateIndividualAddBtn(btn) {
    if (!btn) return;
    var ready = indState && indState.selectedVariantId;
    btn.disabled = !ready;
    btn.textContent = ready
      ? 'Agregar al carrito · ' + indState.price
      : 'Elige interior';
  }

  function adjustQty(delta) {
    var input = indState.modal.querySelector('[data-ind-qty-input]');
    var cur = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, cur + delta);
  }

  function addIndividualToCart(btn) {
    if (!indState || !indState.selectedVariantId) return;
    var qty = parseInt(indState.modal.querySelector('[data-ind-qty-input]').value, 10) || 1;
    var originalText = btn.textContent;
    var status = indState.modal.querySelector('[data-ind-status]');

    btn.disabled = true;
    btn.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(indState.selectedVariantId, 10), quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add-failed'); });
      return r.json();
    })
    .then(function () {
      btn.textContent = '✓ Agregado';
      if (status) { status.textContent = ''; }
      setTimeout(function () {
        indState.modal.hidden = true;
        document.body.style.overflow = '';
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        btn.textContent = originalText;
        btn.disabled = false;
      }, 900);
    })
    .catch(function (err) {
      console.error('[nout-ind]', err);
      btn.textContent = 'Error';
      btn.disabled = false;
      if (status) { status.textContent = 'No se pudo agregar. Intenta de nuevo.'; status.className = 'nout-ind__note is-error'; }
      setTimeout(function () { btn.textContent = originalText; }, 2500);
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

})();
